import { defineMessages } from 'react-intl';

export default defineMessages({
    removeActionLabel: {
        id: 'quoteandbind.ProLinProduct.views.exposures.RemoveActionLabel',
        defaultMessage: 'Delete'
    },
    commercialProLine: {
        id: 'quoteandbind.ProLinProduct.views.exposures.commercialProLine',
        defaultMessage: 'Commercial'
    }
    // add string ids and default values for localization here
});
